// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSDescriptionHeader/index.less
// module id = 1122
// module chunks = 42